<template>
  <div>
    <!-- 面包屑导航 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
      <el-breadcrumb-item>工作台统计</el-breadcrumb-item>
      <el-breadcrumb-item>{{curTitile}}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords2" ref="keywords2Ref" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords2.worklevel" placeholder="请选择任务等级" class="select"  style="width: 150px;">
              <el-option label="请选择任务等级" value="-1"></el-option>
              <el-option label="日常" value="1"></el-option>
              <el-option label="销售" value="2"></el-option>
              <el-option label="研发" value="3"></el-option>
              <el-option label="生产" value="4"></el-option>
              <el-option label="财务" value="5"></el-option>
              <el-option label="其他" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords2.workname" @keyup.enter.native="clicksearch" placeholder="请输入任务名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords2.workuseridcreate" placeholder="请选择创建人" class="select" style="width: 150px;">
              <el-option label="请选择创建人" value="-1"></el-option>
               <el-option
                 v-for="item in erpuserneibulist" :key="item.Id" :label="item.Name" :value="item.Id">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords2.workuseridresponsible" placeholder="请选择责任人" class="select" style="width: 150px;">
              <el-option label="请选择责任人" value="-1"></el-option>
               <el-option
                 v-for="item in erpuserneibulist" :key="item.Id" :label="item.Name" :value="item.Id">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords2.workuseridexecutor" placeholder="请选择执行人" class="select" style="width: 150px;">
              <el-option label="请选择执行人" value="-1"></el-option>
               <el-option
                 v-for="item in erpuserneibulist" :key="item.Id" :label="item.Name" :value="item.Id">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords2.workstatus" placeholder="请选择任务当前状态" class="select"  style="width: 180px;">
              <el-option label="请选择任务当前状态" value="-1"></el-option>
              <el-option label="进行中" value="1"></el-option>
              <el-option label="提前完成" value="2"></el-option>
              <el-option label="按时完成" value="3"></el-option>
              <el-option label="逾期完成" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button plain type="primary" @click="clicksearch(0)">查询</el-button>
            <el-button plain type="primary" @click="clickclearshaixuan()">清空筛选条件</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item>
            <el-badge :value="NumAll" class="item" type="primary">
              <el-button plain @click="clicksearch(-1)">所有任务</el-button>
            </el-badge>
            <el-badge :value="NumDay" class="item" type="primary">
              <el-button plain type="primary" @click="clicksearch(1)">今日任务</el-button>
            </el-badge>
            <el-badge :value="NumWeek" class="item" type="primary">
              <el-button plain type="primary" @click="clicksearch(2)">本周任务</el-button>
            </el-badge>
            <el-badge :value="NumMonth" class="item" type="primary">
              <el-button plain type="primary" @click="clicksearch(3)">本月任务</el-button>
            </el-badge>
            <el-badge :value="NumDelay7" class="item" type="warning">
              <el-button plain type="warning" @click="clicksearch(4)">7日内逾期任务</el-button>
            </el-badge>
            <el-badge :value="NumDelay3" class="item" type="warning">
              <el-button plain type="warning" @click="clicksearch(5)">3日内逾期任务</el-button>
            </el-badge>
            <el-badge :value="NumDelay0" class="item">
              <el-button plain type="danger" @click="clicksearch(6)">已逾期任务</el-button>
            </el-badge>
            <el-badge :value="NumOk" class="item" type="primary">
              <el-button plain @click="clicksearch(7)">已完成任务</el-button>
            </el-badge>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Worklevels" label="任务等级" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Workname" label="任务名称" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workcontent" label="具体内容" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workkeystandard" label="交付物标准" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Workuseridcreates" label="创建人" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workuseridresponsibles" label="责任人" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workuseridexecutors" label="执行人" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Worktimecreate" label="创建时间" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Worktimebegin" label="开始时间" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Worktimeendplan" label="计划结束" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Worktimeendreal" label="实际结束" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workprogress" label="当前进度" header-align="center" align="center" min-width="7%">
            <template v-slot="scope">
              <el-progress type="circle" :percentage="scope.row.Workprogress" :width=60 :color="colors"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="Workstatuss" label="当前状态" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Workreport" label="情况简报" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Workkeyfile" label="交付物内容" header-align="center" align="center" min-width="8%">
            <template v-slot="scope">
              <el-button v-for="Workkeyfile in scope.row.Workkeyfiles" type="text" @click="clickfile(Workkeyfile)">点击查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Workevaluations" label="老板评价" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goWorkevaluation(scope.row)">老板评价</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goWorkreport(scope.row)">情况简报详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="5"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="提交进度" name="three" disabled="disabled">
        <WorkbenchStatisticalValuation ref="SubVuethree" v-on:triggerFunc="BackToFirst"></WorkbenchStatisticalValuation>
      </el-tab-pane>

      <el-tab-pane label="情况简报详情" name="four" disabled="disabled">
        <WorkbenchsingleReport ref="SubVuefour" v-on:triggerFunc="BackToFirst"></WorkbenchsingleReport>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import ChooseMultiErpUsers from '@/components/ChooseMultiErpUsers.vue'
import WorkbenchStatisticalValuation from '@/componentsSubVue/WorkbenchStatisticalValuation.vue'
import WorkbenchsingleReport from '@/componentsSubVue/WorkbenchsingleReport.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    ChooseMultiErpUsers,
    WorkbenchStatisticalValuation,
    WorkbenchsingleReport
  },
  name: 'MyWorkbenchstatistical',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      curTitile: '所有任务',
      // 筛选条件
      keywords2: {
        worklevel: '-1',
        workname: '',
        workuseridcreate: '-1',
        workuseridresponsible: '-1',
        workuseridexecutor: '-1',
        workstatus: '-1'
      },
      keywords: {
        querytype: 0
      },
      colors: [
        { color: '#f56c6c', percentage: 40 },
        { color: '#e6a23c', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#5cb87a', percentage: 100 }
      ],
      // 添加
      addData: {
        worklevel: '',
        workname: '',
        workcontent: '',
        workkeystandard: '',
        workuseridresponsible: '',
        workuseridexecutor: '',
        worktimebegin: '',
        worktimeendplan: ''
      },
      NumAll: 0,
      NumDay: 0,
      NumWeek: 0,
      NumMonth: 0,
      NumDelay7: 0,
      NumDelay3: 0,
      NumDelay0: 0,
      NumOk: 0,
      Useriderp: 0,
      erpuserneibulist: []
    }
  },
  mounted () {
    this.apiGetWorkbenchsingleNum()
    this.apiGetWorkbenchsingleList()

    this.Useriderp = localStorage.getItem('Useriderp')

    this.apigeterpuserneibulist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetWorkbenchsingleNum()
      this.apiGetWorkbenchsingleList()
    },
    changeMultiErpUsers1 (rv) {
      this.addData.workuseridresponsible = rv
    },
    changeMultiErpUsers2 (rv) {
      this.addData.workuseridexecutor = rv
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiGetWorkbenchsingleNum()
      this.apiGetWorkbenchsingleList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWorkbenchsingleList()
    },
    clickclearshaixuan () {
      this.keywords2.worklevel = '-1'
      this.keywords2.workname = ''
      this.keywords2.workuseridcreate = '-1'
      this.keywords2.workuseridresponsible = '-1'
      this.keywords2.workuseridexecutor = '-1'
      this.keywords2.workstatus = '-1'
      this.clicksearch(0)
    },
    clicksearch (querytype) {
      this.selectedPageNo = 1
      this.keywords.querytype = querytype

      if (querytype === 0) {
        this.curTitile = '所有任务'
      }
      if (querytype === 1) {
        this.curTitile = '今日任务'
      }
      if (querytype === 2) {
        this.curTitile = '本周任务'
      }
      if (querytype === 3) {
        this.curTitile = '本月任务'
      }
      if (querytype === 4) {
        this.curTitile = '7日内逾期任务'
      }
      if (querytype === 5) {
        this.curTitile = '3日内逾期任务'
      }
      if (querytype === 6) {
        this.curTitile = '已逾期任务'
      }
      if (querytype === 7) {
        this.curTitile = '已完成任务'
      }

      this.apiGetWorkbenchsingleNum()
      this.apiGetWorkbenchsingleList()
    },
    clickadd () {
      this.apiAddWorkbenchsingle()
    },
    clickdelete (row) {
      this.$confirm('是否删除此任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteWorkbenchsingle(row)
      })
    },
    goWorkevaluation (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ workbenchid: row.Id })
    },
    goWorkreport (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ workbenchid: row.Id })
    },
    apiGetWorkbenchsingleList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        querytype: that.keywords.querytype,
        worklevel: that.keywords2.worklevel,
        workname: that.keywords2.workname,
        workuseridcreate: that.keywords2.workuseridcreate,
        workuseridresponsible: that.keywords2.workuseridresponsible,
        workuseridexecutor: that.keywords2.workuseridexecutor,
        workstatus: that.keywords2.workstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkbenchStatisticalList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.NumAll = response.data.NumAll
            that.NumDay = response.data.NumDay
            that.NumWeek = response.data.NumWeek
            that.NumMonth = response.data.NumMonth
            that.NumDelay7 = response.data.NumDelay7
            that.NumDelay3 = response.data.NumDelay3
            that.NumDelay0 = response.data.NumDelay0
            that.NumOk = response.data.NumOk
            for (var i = 0; i < that.dataList.length; i++) {
              var buf = that.dataList[i].Workkeyfile.split('@@@')
              if (buf.length > 0 && buf[0].length > 0) {
                that.dataList[i].Workkeyfiles = buf
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkbenchsingleNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: that.keywords.querytype,
        worklevel: that.keywords2.worklevel,
        workname: that.keywords2.workname,
        workuseridcreate: that.keywords2.workuseridcreate,
        workuseridresponsible: that.keywords2.workuseridresponsible,
        workuseridexecutor: that.keywords2.workuseridexecutor,
        workstatus: that.keywords2.workstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkbenchStatisticalNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddWorkbenchsingle: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        worklevel: that.addData.worklevel,
        workname: that.addData.workname,
        workcontent: that.addData.workcontent,
        workkeystandard: that.addData.workkeystandard,
        workuseridresponsible: that.addData.workuseridresponsible,
        workuseridexecutor: that.addData.workuseridexecutor,
        worktimebegin: that.addData.worktimebegin,
        worktimeendplan: that.addData.worktimeendplan
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddWorkbenchsingle, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.worklevel = ''
            that.addData.workname = ''
            that.addData.workcontent = ''
            that.addData.workkeystandard = ''
            that.addData.workuseridresponsible = ''
            that.addData.workuseridexecutor = ''
            that.addData.worktimebegin = ''
            that.addData.worktimeendplan = ''

            that.$refs.MultiErpUsers1.cleardata()
            that.$refs.MultiErpUsers2.cleardata()

            that.keywords.querytype = 0
            that.apiGetWorkbenchsingleNum()
            that.apiGetWorkbenchsingleList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteWorkbenchsingle: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workbenchid: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteWorkbenchStatistical, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetWorkbenchsingleNum()
            that.apiGetWorkbenchsingleList()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigeterpuserneibulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpuserneibulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.erpuserneibulist = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
